module.exports = __webpack_public_path__ + "20240105162613/img/no-data.ad08b269.png";